import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ChangeContentProvider from './context/contentContext';
import CreatePassword from "./pages/createPassword";
import SignIn from "./pages/signin";
import UserManagement from "./pages/usermanagement/userMange";
import AddUser from "./pages/usermanagement/addUser";
import EditUser from "./pages/usermanagement/editUser";
import ViewUser from "./pages/usermanagement/viewUser";
import AppConfig from "./pages/settings/appConfig";
import Profile from "./pages/profile";
import Client from "./pages/clientmanagement/client"
import EditClient from "./pages/clientmanagement/editclient"
import ViewClient from "./pages/clientmanagement/viewClient"
import NotFound from "./pages/NotFound";
import GeneratePassword from "./pages/pwdGenerate";
import StoreManage from "./pages/storemanagement/storeManage";
import DashBoard from "./pages/dashboard/dashboard";
import VerifyAccount from "./pages/verifyAccount";
import SignUp from "./pages/signUp";
import Request from "./pages/request";
import AdminLogin from "./pages/adminLogin";
import EditStore from "./pages/storemanagement/editStore";
import SwaggerComponent from "./pages/Swagger";
import Category from "./pages/categorymanagement/category";
import ClientUserList from "./pages/clientUsermanagement/userList";
import ClientUserDetails from "./pages/clientUsermanagement/userDetails";
import ViewClientUser from "./pages/clientUsermanagement/viewClientUser";
import SpotsManage from "./pages/Spots/spotsmanage";
import BusinessProfile from "./pages/businessProfile";
import Spots from "./pages/Spots/spots";
import UpgradePage from "./pages/upgrade";
import Subscriptions from "./pages/subscriptions/subcription";
import EditSubscriptions from "./pages/subscriptions/editSubscriptions";
import Notification from "./pages/notificationmanagement/notification";
import Transactions from "./pages/transactions";
import Revenue from "./pages/revenue";
import Payouts from "./pages/payouts";
import ViewDashboard from "./pages/dashboard/viewDashboard";
import LandingScreen from "./pages/visitorSettingsConfiguration/landingScreen";
import MenuGuard from "./components/menuGuard";
import { canManageUsers } from "./utils/adminRoles";

// import SubscriptionPlan from "./pages/subscriptions/subscriptionplan";
// import PaymentPage from "./pages/subscriptions/PaymentPage";


function App() {
  return (
    <BrowserRouter>
      <ChangeContentProvider>
        <Routes>
        <Route path="/" element={<AdminLogin />} />
          {/* <Route path="/signin" element={<SignIn />} /> */}
          {/* <Route path="/signin/:id" element={<SignIn />} /> */}
          <Route path="/createpassword" element={<CreatePassword />} />
          {/* <Route path="/login" element={<SignIn />} /> */}
          <Route path="/users" element={<UserManagement />} />

          {/* <Route path="/clientusers" element={<ClientUserList />} />
          <Route path="/clentadduser" element={<ClientUserDetails />} />
          <Route path="/clentedituser/:id" element={<ClientUserDetails />} />
          <Route path="/viewclientuser/:id" element={<ViewClientUser />} />
          <Route path="/spots" element={<Spots />} />
          <Route path="/upgradeplan" element={<UpgradePage />} />
        
       
          <Route path="/addsubscription" element={<EditSubscriptions />} />

          <Route path="/spotsmanage/:id" element={<SpotsManage />} />
          <Route path="/businessprofile" element={<BusinessProfile />} />
          <Route path="/createuser" element={<AddUser />} /> */}
           <Route path="/subscriptions" element={<MenuGuard menu="Subscriptions"><Subscriptions /></MenuGuard>} />
          <Route path="/adduser" element={<MenuGuard menu="Users" allow={canManageUsers}><EditUser /></MenuGuard>} />
          <Route path="/edituser/:id" element={<MenuGuard menu="Users" allow={canManageUsers}><EditUser /></MenuGuard>} />
          <Route path="/viewuser/:id" element={<ViewUser />} />
          <Route path="/categories" element={<Category />} />
          <Route path="/notifications" element={<Notification />} />

          <Route path="/settings/:id" element={<AppConfig />} />
          <Route path="/profile" element={<Profile />} />
          {/* "Settings" is a single sidebar menu with no submenus, so clicking it
              navigates to the bare /settings. Only /settings/:id has a component,
              so without this the catch-all below rendered NotFound. */}
          <Route path="/settings" element={<Navigate to="/settings/appconfig" replace />} />
          <Route path="*" element={<NotFound />} />
          
         
          {/* <Route path="/verifyaccount" element={<VerifyAccount />} /> */}
          {/* <Route path="/thankyou" element={<Request />} /> */}
          <Route path="/dashboard" element={<DashBoard />} />
           <Route path="/viewdashboard/:id" element={<ViewDashboard />} />
          {/* <Route path="/storemanagement" element={<StoreManage />} /> */}
          {/* <Route path="/generatepwd" element={<GeneratePassword />} /> */}
          <Route path="/clients" element={<Client />} />
          <Route path="/editclient/:id" element={<EditClient />} />
          <Route path="/viewclient/:id" element={<ViewClient />} />
          <Route path="/addclient" element={<EditClient />} />
          <Route path="/transactions" element={<MenuGuard menu="Transactions"><Transactions /></MenuGuard>} />
          <Route path="/revenue" element={<MenuGuard menu="Revenue"><Revenue /></MenuGuard>} />
          <Route path="/payouts" element={<MenuGuard menu="Payouts"><Payouts /></MenuGuard>} />
          {/* <Route path="/addstore"element={<EditStore />}/>
          <Route path="/editstore/:id"element={<EditStore />}/> */}
          <Route path="/swagger"element={<SwaggerComponent />}/>
          <Route path="/visitorappsettings"element={<LandingScreen />}/>

        </Routes>
      </ChangeContentProvider>
    </BrowserRouter>
  );
}

export default App;

